import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "button"];
  static values = { showLabel: String, hideLabel: String };

  toggle() {
    this.setVisible(this.inputTarget.type === "password");
  }

  hideOnSubmit(event) {
    if (event.target.contains(this.element)) this.setVisible(false);
  }

  hideIfRestored(event) {
    if (event.persisted) this.setVisible(false);
  }

  setVisible(visible) {
    this.inputTarget.type = visible ? "text" : "password";
    this.buttonTarget.setAttribute("aria-label", visible ? this.hideLabelValue : this.showLabelValue);
    this.buttonTarget.classList.toggle("is-visible", visible);
  }
}
